import {useParams} from 'next/navigation';

import {AppCategory, NO_CATEGORY_CATEGORY} from '@web-catalog/types';

import {useCategoriesAtomValue} from '@web-catalog/store';

import {findCategoryData} from '@web-catalog/utils';

import {useIsGamesPage} from './useIsGamesPage/useIsGamesPage';

export const useActiveCategory = (): AppCategory | null => {
  const isGamesPage = useIsGamesPage();
  const {category: paramsCategory} = useParams();
  const {appsCategories, gamesCategories} = useCategoriesAtomValue();

  if (!paramsCategory) {
    return null;
  }

  const categories = isGamesPage ? gamesCategories : appsCategories;

  const activeCategory =
    typeof paramsCategory === 'string' &&
    paramsCategory !== NO_CATEGORY_CATEGORY
      ? findCategoryData(categories, paramsCategory)
      : null;

  return activeCategory;
};
